import { getCanvasPositionAndSize } from "@/lib/canvas/helpers";

export function getRightClickMenuPositionInCanvas(
  mouseX: number,
  mouseY: number
) {
  const { x: canvasX, y: canvasY } = getCanvasPositionAndSize();

  const iframe = document.getElementById("iframe");

  const menuElement = window.Breakdance.canvas.document.querySelector(
    ".breakdance-canvas-right-click-menu"
  ) as HTMLElement;

  if (!menuElement || !iframe) {
    return;
  }

  const { width: iframeWidth, height: iframeHeight } =
    iframe.getBoundingClientRect();

  const { menuWidth, menuHeight } = getMenuSize(menuElement);

  const x =
    mouseX + menuWidth + 15 > iframeWidth
      ? mouseX - canvasX - menuWidth
      : mouseX - canvasX;

  const y =
    mouseY + menuHeight + 15 > iframeHeight
      ? mouseY - canvasY - menuHeight
      : mouseY - canvasY;

  return {
    x,
    y
  };
}

function getMenuSize(menuElement: HTMLElement) {
  // getBoundingClientRect sizes will be 0 if the element is hidden
  menuElement.style.display = "block";
  const { width, height } = menuElement.getBoundingClientRect();

  return {
    menuWidth: width,
    menuHeight: height
  };
}
